import { render, staticRenderFns } from "./HistoryHome.vue?vue&type=template&id=13c97ec1&scoped=true&"
import script from "./HistoryHome.vue?vue&type=script&lang=js&"
export * from "./HistoryHome.vue?vue&type=script&lang=js&"
import style0 from "./HistoryHome.vue?vue&type=style&index=0&id=13c97ec1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c97ec1",
  null
  
)

export default component.exports